module.exports = __webpack_public_path__ + "img/troubleshooting_tool.bd2fb.png";